import React, { Component } from 'react'
import PropTypes from 'prop-types'
import media from '../../media';

import './styles.css'

class MainCarousel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            slides: [
                {
                    id: 'slide1',
                    text: "През 1762 г. един неизвестен дотогава български монах, чието име днес разпознаваме като Паисий Хилендарски, съставя малка ръкописна книжица, а тя отключва обемен духовен и културен национален процес, защото разбужда дотогавашната България.",
                    image: media['paisii']
                }, {
                    id: 'slide2',
                    text: "Колцина са съвременните българи, които са прочели „История славянобългарска“ от кора до кора?",
                    image: media['history_slide']
                }, {
                    id: 'slide3',
                    text: "Колцина са съвременните българи, които разпознават, че в редовете и междуредията на Паисиевата книжица има отломъци от гняв срещу юродивите българи, които се гърчеят и ги е срам да останат българи?",
                    image: media['quill']
                }, {
                    id: 'slide4',
                    text: "Колцина са съвременните българи, които знаят, че в Паисиевата книга има гняв, но има и огън, възпламенен от искра, родена в дълбокото на сърцето, която захранва с огнена любов към всичко, което е българско?",
                    image: media['slide4']
                }, {
                    id: 'slide5',
                    text: "Колцина са съвременните българи, които помнят, че малката книжица на Паисий се множи в образи, ръкописвани 117 години на ръка и предавани нататък?",
                    image: media['kovanlak_slide']
                }, {
                    id: 'slide6',
                    text: "Книги, които днес би трябвало да ни докосват отвътре, защото сме потомци на „учениците“ на Отец Паисий (образът е на Марин Дринов), а и защото и ние раждаме българи.",
                    image: media['slide6']
                }, {
                    id: 'slide7',
                    text: "Или пък би трябвало да ни зашлевяват плесници, когато се правим, че не знаем, че ги е имало и Тях, възрожденските ни достойни предци, и че ги имаме и днес... Този разказ е от Големите разкази в българската духовност и култура! ПРЕДАЙ НАТАТЪК!",
                    image: media['slide7']
                }
            ]
        }
    }
    componentDidMount() {
        this.refs.player.volume = 0.1;
    }
    render(){
        return (
            <div id="carousel_main" className="carousel slide carousel-fade" data-ride="carousel">
                <ol className="carousel-indicators">
                    {this.state.slides.map((slide, index) => (
                        <li data-target="#carousel_main" data-slide-to={index} className={index === 0 ? 'active' : ''}/>
                    ))}
                </ol>
                <div className="carousel-inner">
                    {this.state.slides.map(slide => (
                        <div key={slide.id} className={`carousel-item ${slide.id === 'slide1' ? 'active' : ''}`} style={{backgroundImage: `url(${slide.image})`}}>
                            <p>{slide.text}</p>
                        </div>
                    ))}
                </div>
                <a className="carousel-control-prev" href="#carousel_main" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"/>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#carousel_main" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"/>
                    <span className="sr-only">Next</span>
                </a>
                <audio src={media['chant']} autoPlay={true} loop={true} ref="player" />
            </div>
        )
    }
}

MainCarousel.propTypes = {

}

export default MainCarousel



// WEBPACK FOOTER //
// ./src/components/MainCarousel/index.jsx